module.exports = __webpack_public_path__ + "img/helpcneter.bf92d844.jpg";